import React from "react";
import { Box, Skeleton } from "@mui/material";

function LoadingSkeleton({ variant = "table", rows = 5 }) {
  if (variant === "cards") {
    return (
      <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
        {[...Array(4)].map((_, i) => (
          <Box key={i} sx={{ flex: "1 1 220px", minWidth: 220 }}>
            <Skeleton
              variant="rounded"
              height={140}
              sx={{ borderRadius: 3 }}
            />
          </Box>
        ))}
      </Box>
    );
  }

  if (variant === "chart") {
    return (
      <Box>
        <Skeleton variant="text" width={200} height={32} sx={{ mb: 2 }} />
        <Skeleton variant="rounded" height={300} sx={{ borderRadius: 3 }} />
      </Box>
    );
  }

  // table variant (default)
  return (
    <Box>
      <Skeleton variant="rounded" height={48} sx={{ mb: 1, borderRadius: 1 }} />
      {[...Array(rows)].map((_, i) => (
        <Skeleton
          key={i}
          variant="rounded"
          height={52}
          sx={{ mb: 0.5, borderRadius: 1 }}
        />
      ))}
    </Box>
  );
}

export default LoadingSkeleton;
